import React, { Component } from 'react'

import '../../css/BisharatMain.css';
import MemberDataService from '../../services/MemberDataService';
import profileImg from '../../data/images/profileImg.jpg';
import { ENV_URL } from '../../services/Globals';
import AuthService from "../../services/AuthService";
import translate from '../../languages/translate';
export default class MemberDetail extends Component {
    state = {
        oneMember: [],
        partners: [],
        haveRoleOfAdminOrMod: false
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        const memberId = params.id;
        MemberDataService.getMember(memberId)
            .then(res => {
                MemberDataService.getPartners(memberId).then(res => {
                    const partners = res.data;
                    this.setState({ partners });
                    console.log(partners)
                })
                const oneMember = res.data;
                this.setState({ oneMember });
            })
        const whatRole = AuthService.getUserRole();
        if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
            this.setState({ haveRoleOfAdminOrMod: true });
        }
    }


    goToFamilyTree(id) {
        // window.open(`/family-tree/${id}`, '_blank');
        window.location.href = `/family-tree/${id}`;
    }


    gotoMemberEdit(id) {
        window.location.href = `/family-members/${id}/edit`;
    }


    showPartner(id) {
        window.location.href = `/family-partners/${id}`;
}
 


    render() {


        
        return (
            <div className="top-level-page-main member-detail">
                <div className="view-details member-detail ">
                    <div className="card-details">

                        <div className="prfile-signed">
                            {this.state.oneMember.userProfileImageLink ?
                                <img
                                    src={`${ENV_URL}/api/v1/members/${this.state.oneMember.id}/download`}
                                    alt="profile"
                                /> :
                                <img
                                    src={profileImg}
                                    alt="profile-img"
                                />
                            }
                        </div>


                        <div className="card-group-field">
                            <h5>  {translate("name")}   </h5>
                            <h4> {this.state.oneMember.name}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h5>    {translate("father-name")}   </h5>
                            <h4> {this.state.oneMember.fatherName ? this.state.oneMember.fatherName : <h4>{translate("notfound")}</h4>}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h5>   {translate("mother-name")}    </h5>
                            <h4> {this.state.oneMember.motherName ? this.state.oneMember.motherName : <h4>{translate("notfound")}</h4>}   </h4>
                        </div>
                        {this.state.partners.length > 0 && (
                        <div className="card-group-field">
                            <h5>   {translate("partner")}    </h5>
                            <h4>
                                {this.state.partners.map(partner => (
                                    <button className="btn-reset" key={partner.id} onClick={() => this.showPartner(partner.id)}> {partner.name} </button>
                                ))}
                            </h4>
                        </div>
                        )}
                        
                        <div className="card-group-field">
                            <h5>  {translate("birthdate")} </h5>
                            <h4> {(this.state.oneMember.birthdate) ? this.state.oneMember.birthdate : <h4>{translate("notfound")}</h4>}   </h4>
                        </div>
                    

                        {this.state.haveRoleOfAdminOrMod && <>

                            <div className="card-group-field">
                            <h5>   {translate("address")} </h5>
                            <h4> {this.state.oneMember.address ? this.state.oneMember.address : <h4>{translate("notfound")}</h4>}   </h4>
                        </div>

                            <div className="card-group-field">
                                <h5> ID </h5>
                                <h4> {this.state.oneMember.id}</h4>
                            </div>

                            <div className="card-group-field">
                                <h5> {translate("phone-num")} </h5>
                                <h4> {this.state.oneMember.phoneNumber ? this.state.oneMember.phoneNumber : <h4>{translate("notfound")}</h4>}   </h4>
                            </div>

                            <div className="card-group-field">
                                <h5> {translate("identity")} </h5>
                                <h4> {this.state.oneMember.identity ? this.state.oneMember.identity : <h4>{translate("notfound")}</h4>}   </h4>
                            </div>

                            <div className="card-group-field">
                                <h5> {translate("status-fam")}   </h5>
                                <h4> {(this.state.oneMember.isMarried === 'yes') ? translate("married") : translate("not-married")}   </h4>
                            </div>
                            <div className="card-group-field">
                                <h5> {translate("alive")}  </h5>
                                <h4> {this.state.oneMember.isAlive === 'yes' ? translate("yes") : translate("no")}   </h4>
                            </div>
                            <div className="card-group-field">
                            <h5>  {translate("gender")}  </h5>
                            <h4> {this.state.oneMember.gender === 'male' ? translate("male") : translate("female") } </h4>
                        </div>
                        </>
                        }


                        <button className="btn" onClick={() => this.goToFamilyTree(this.state.oneMember.id)}>{translate("fa-tree-person")}  </button>
                        {this.state.haveRoleOfAdminOrMod ?
                        <>
                            <button className="btn" onClick={() => this.gotoMemberEdit(this.state.oneMember.id)}>{translate("edit")}</button>
                            </>
                            : <></>
                        }

                        <button className="btn" onClick={this.props.history.goBack}>  {translate("back")}  </button>
                    </div>
                </div>
            </div>
        )
    }
}
